import { createGlobalStyle } from 'styled-components';

import { Styles } from './styles';

export const GlobalStyle = createGlobalStyle`
  ${Styles}
`;
